import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import AdminHeader from "./AdminHeader"; // your neon header with Logout

export default function ProtectedAdmin() {
  const { loading, user, isAdmin } = useAuth();

  if (loading) {
    return (
      <div className="min-h-[50vh] grid place-items-center">
        <div className="animate-pulse text-[#D4FF00] font-semibold">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (!isAdmin)
    return (
      <div className="min-h-[50vh] grid place-items-center">
        <div className="rounded-xl border border-red-500/40 bg-black/70 p-6 text-red-400">
          403 — Admins only
        </div>
      </div>
    );

  return (
    <>
      <Outlet />
    </>
  );
}
